import { Component, OnInit, Inject } from '@angular/core';
import { MatChipInputEvent, MatSnackBar } from '@angular/material';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { GatewayService } from 'src/app/gateway.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSortModule, MatSort } from '@angular/material';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentTabController } from 'src/app/tab-controller';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
	selector: 'app-create-alarma',
	templateUrl: './create-alarma.component.html',
	styleUrls: ['./create-alarma.component.scss']
})
export class CreateAlarmaComponent implements OnInit {

	visible = true;
	selectable = true;
	removable = true;
	addOnBlur = true;
	correos: any[] = [];
	readonly separatorKeysCodes: number[] = [ENTER, COMMA];
	alarmaColumns: any = ['CORREO', 'NIVELALARMA', 'TIPOALARMA', 'ACCION'];
	dataSource = new MatTableDataSource<any>([]);
	razones: any = [];
	idpais;
	FILTER;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data,
		private gateway: GatewayService,
		private spinner: NgxSpinnerService,
		private dialogRef: MatDialogRef<CreateAlarmaComponent>,
		public localSave: LocalSaveService,
		private tabController: ComponentTabController,
		public snackbar: MatSnackBar
	) { }

	ngOnInit() {
		this.idpais = this.localSave.get('pais');

		if (this.localSave.get('solo_ver')) {
			this.alarmaColumns = ['CORREO', 'NIVELALARMA', 'TIPOALARMA'];
		} else {
			this.alarmaColumns = ['CORREO', 'NIVELALARMA', 'TIPOALARMA', 'ACCION'];
		}

		// console.log(this.idpais);
		this.getAlarma();
		this.getRazones();
	}

	getRazones() {
		this.gateway.get('listarazon', { NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais }).then((result: any) => {
			//console.log(result.rows);
			this.razones = result.rows;
		}
		).catch(function (e) {
		});
	}

	grupoVal = new FormGroup({
		nivelalarma: new FormControl('', Validators.required),
		tipoalarma: new FormControl('', Validators.required),
		correo: new FormControl('', Validators.compose([Validators.required, Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]))
	});

	removealarm(alarm) {
		// console.log(alarm);
		let data = this.dataSource.data;
		let index = data.map((e) => { return JSON.stringify(e); }).indexOf(JSON.stringify(alarm));
		if (index != -1) { data.splice(index, 1); }
		this.dataSource.data = data;
	}

	onNoClick() {
		this.localSave.delete('campana');
		this.dialogRef.close();
	}

	add(event: MatChipInputEvent): void {
		const input = event.input;
		const value = event.value;

		// Add our emails
		if ((value || '').trim()) {
			if (this.validateEmail(value.trim())) {
				this.correos.push(value.trim());
			} else {
				this.snackbar.open("Correo no valido.", 'Cerrar', { duration: 3000 });
			}
		}

		// Reset the input value
		if (input) {
			input.value = '';
		}
	}

	validateEmail(email) {
		const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	remove(correo: any): void {
		const index = this.correos.indexOf(correo);

		if (index >= 0) {
			this.correos.splice(index, 1);
		}
	}

	getAlarma() {
		this.gateway.get('obteneralarma', { IDCAMPANA: this.localSave.get('campana') }).then((result: any) => {
			const auxresult: any = result.rows;
			let data = [];
			// console.log(auxresult);
			auxresult.map((alarma) => {

				let alarm = { idnivelalarma: '', nivelalarma: '', idtipoalarma: '', tipoalarma: '', correo: '' };
				const exist = this.correos.map((email) => { return email }).indexOf(alarma.correo);
				if (exist == -1) {
					this.correos.push(alarma.correo);
				}

				alarma.nivel == 1 ? alarm.nivelalarma = 'Alto' : '';
				alarma.nivel == 2 ? alarm.nivelalarma = 'Medio' : '';
				alarma.nivel == 3 ? alarm.nivelalarma = 'Bajo' : '';
				alarma.nivel == 4 ? alarm.nivelalarma = 'Nivel 4' : '';

				alarm.tipoalarma = alarma.nombre;
				alarm.idnivelalarma = alarma.nivel;
				alarm.idtipoalarma = alarma.tipo;
				alarm.correo = alarma.correo;

				const existalarm = data.map((alarm) => { return JSON.stringify(alarm) }).indexOf(JSON.stringify(alarm));
				if (existalarm == -1) {
					data.push(JSON.parse(JSON.stringify(alarm)));
				}

			});
			this.dataSource = new MatTableDataSource(data);
			// console.log('====')
			// console.log(data)
			// console.log(dataSource)
			// console.log('//====')
		}
		).catch(function (e) {
		});

	}

	async addalarm() {
		for (let index = 0; index < this.grupoVal.controls.tipoalarma.value.length; index++) {
			const element = this.grupoVal.controls.tipoalarma.value[index];
			await this.addalarm2(element)
		}
		this.grupoVal.controls.correo.setValue('');
		this.grupoVal.controls.correo.reset();
		// this.grupoVal.reset();
	}

	async addalarm2(tipoalarma) {
		return new Promise((resolve, reject) => {
			const alarm = { idnivelalarma: '', nivelalarma: '', idtipoalarma: '', tipoalarma: '', correo: '' };
			this.grupoVal.controls.nivelalarma.value == 1 ? alarm.nivelalarma = 'Alto' : '';
			this.grupoVal.controls.nivelalarma.value == 2 ? alarm.nivelalarma = 'Medio' : '';
			this.grupoVal.controls.nivelalarma.value == 3 ? alarm.nivelalarma = 'Bajo' : '';
			this.grupoVal.controls.nivelalarma.value == 4 ? alarm.nivelalarma = 'Nivel 4' : '';
			alarm.idnivelalarma = this.grupoVal.controls.nivelalarma.value;
			alarm.correo = this.grupoVal.controls.correo.value;
			alarm.tipoalarma = tipoalarma.nombre; // this.grupoVal.controls.tipoalarma.value.nombre;
			alarm.idtipoalarma = tipoalarma.idrazon; // this.grupoVal.controls.tipoalarma.value.idrazon;
			let data = [];
			data = this.dataSource.data;
			// console.log(data);
			if (data.find(element => { return alarm.tipoalarma === element.tipoalarma && alarm.idnivelalarma == element.idnivelalarma && alarm.correo == element.correo })) {
				this.snackbar.open('Alarma ya existente', 'Cerrar', { duration: 3000, });
				// this.grupoVal.controls.correo.setValue('');
				// this.grupoVal.controls.correo.reset();
				return resolve(false);
			} else {
				data.push(alarm);
				// this.grupoVal.controls.correo.setValue('');
				// this.grupoVal.controls.correo.reset();
				this.dataSource = new MatTableDataSource(data);
				return resolve(true);
			}
		});
	}

	save() {
		let ALARMA = {
			correo: '',
			nivel: '',
			tipo: '',
			idcampana: this.localSave.get('campana')
		};
		const data = this.dataSource.data;
		const sendinfo = [];
		this.spinner.show();
		// this.correos.map((correo) => {
		// 	ALARMA.correo = correo;
		// 	 console.log(correo);
		// 	data.map((confalarma) => {
		// 		ALARMA.nivel = confalarma.idnivelalarma;
		// 		ALARMA.tipo = confalarma.idtipoalarma;
		// 		 console.log(ALARMA);
		// 		sendinfo.push(JSON.parse(JSON.stringify(ALARMA)));
		// 	});
		// });
		this.gateway.save('cleanalarma', { IDCAMPANA: this.data.idcampana }).then((result) => {
			//this.fnsendinfo(sendinfo, 0);
			this.fnsendinfo(data, 0);
		}
		).catch(function (e) {
		});
	}

	fnsendinfo(alarmas, index) {
		if (index < alarmas.length - 1) {
			// console.log(alarmas);
			alarmas[index].idcampana = this.localSave.get('campana');
			this.gateway.save('createalarma', alarmas[index]).then((result) => {
				this.fnsendinfo(alarmas, ++index);
			}
			).catch(function (e) {
			});
		} else {
			alarmas[index].idcampana = this.localSave.get('campana');
			this.gateway.save('createalarma', alarmas[index]).then((result) => {
				this.spinner.hide();
				this.tabController.index = 3;
			}
			).catch(function (e) {
			});
		}
	}

	getError(type) {
		if (type == 1) {
			if (this.grupoVal.controls.nivelalarma.hasError('required')) {
				return 'Debes seleccionar un Nivel de Alarma';
			}
		}
		if (type == 2) {
			if (this.grupoVal.controls.tipoalarma.hasError('required')) {
				return 'Debes seleccionar una Razón de Alarma';
			}
		}
	}
}

